import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import Iconify from "../../../minimals/components/iconify";
import { BlacklistEntityType } from "../types";
import CreateMatchResolutionRequestModal from "./CreateMatchResolutionRequestModal";

interface MatchResolutionRequestCellProps {
  entityId: number;
  entityType: BlacklistEntityType;
  entityLabel?: string;
  refreshData: () => Promise<void>;
}

const MatchResolutionRequestCell = ({
  entityId,
  entityType,
  entityLabel,
  refreshData
}: MatchResolutionRequestCellProps) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <>
      <Tooltip title="Request lookup-code match resolution">
        <IconButton color="primary" onClick={() => setIsCreateModalOpen(true)}>
          <Iconify icon="eva:checkmark-circle-2-outline" width={24} />
        </IconButton>
      </Tooltip>
      {isCreateModalOpen && (
        <CreateMatchResolutionRequestModal
          open={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
          entityId={entityId}
          entityType={entityType}
          entityLabel={entityLabel}
          onActionComplete={refreshData}
        />
      )}
    </>
  );
};

export const createMatchResolutionRequestColumn = <T extends { id: number; name?: string; firstName?: string; lastName?: string }>(
  refreshData: () => Promise<void>,
  entityType: BlacklistEntityType
) => ({
  id: "matchResolutionRequest",
  header: "Match Resolution",
  Cell: ({ row }: { row: { original: T } }) => {
    const entityLabel = row.original.name || [row.original.firstName, row.original.lastName].filter(Boolean).join(" ");

    return (
      <MatchResolutionRequestCell
        entityId={row.original.id}
        entityType={entityType}
        entityLabel={entityLabel}
        refreshData={refreshData}
      />
    );
  },
  size: 50,
  enableSorting: false,
  enableColumnFilter: false,
  muiTableBodyCellProps: { sx: { verticalAlign: "top" } }
});
